import { render } from "./issuePopup.vue?vue&type=template&id=7886421e&ts=true"
import script from "./issuePopup.vue?vue&type=script&lang=ts"
export * from "./issuePopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__